import request from 'utils/request_ajax';
import jwtDecode from 'jwt-decode';
import supportsLocalStorage from './supportsLocalStorage';

export const replaceCAToken = async accessToken => {
  if (accessToken === null || accessToken.trim() === '') {
    return 'accessToken is required';
  }

  try {
    await request.get('/content', { seismicToken: accessToken, replace: 1 });
    localStorage.setItem('seismicAuthToken', accessToken);
    return 'success';
  } catch {
    return 'failed';
  }
};

export const isAuthTokenValid = authToken => {
  if (!authToken) {
    return false;
  }
  try {
    const decoded = jwtDecode(authToken);
    const now = new Date();
    // Create a date with the value of the token exp date minus 5 minutes
    const tokenExp = new Date(decoded?.exp * 1000 - 300_000);
    if (now > tokenExp) {
      throw new Error('Auth token has expired');
    }
    return true;
  } catch (e) {
    console.warn(e.message);
    return false;
  }
};

export const removeAuthTokenFromLocalStorage = () => {
  const AUTHTOKEN = 'seismicAuthToken';
  if (supportsLocalStorage && localStorage.getItem(AUTHTOKEN)) {
    localStorage.removeItem(AUTHTOKEN);
  }
};
